// extracted by mini-css-extract-plugin
export default {"deleteIconBtn":"styles_deleteIconBtn__3HCJn"};